export const FETCH_CUSTOMER_CENTER_CONFIGURATION_REQUEST =
    'FETCH_CUSTOMER_CENTER_CONFIGURATION_REQUEST';
export const FETCH_CUSTOMER_CENTER_CONFIGURATION_SUCCESS =
    'FETCH_CUSTOMER_CENTER_CONFIGURATION_SUCCESS';
export const FETCH_CUSTOMER_CENTER_CONFIGURATION_FAILURE =
    'FETCH_CUSTOMER_CENTER_CONFIGURATION_FAILURE';

export const UPDATE_CUSTOMER_CENTER_CONFIGURATION_REQUEST =
    'UPDATE_CUSTOMER_CENTER_CONFIGURATION_REQUEST';
export const UPDATE_CUSTOMER_CENTER_CONFIGURATION_SUCCESS =
    'UPDATE_CUSTOMER_CENTER_CONFIGURATION_SUCCESS';
export const UPDATE_CUSTOMER_CENTER_CONFIGURATION_FAILURE =
    'UPDATE_CUSTOMER_CENTER_CONFIGURATION_FAILURE';

export const RESET_CONFIGURATION_SUCCESS =
    'RESET_CONFIGURATION_SUCCESS';
